function c(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var o = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var i;
function p() {
  return i || (i = 1, function(e) {
    (function() {
      var u = {}.hasOwnProperty;
      function s() {
        for (var t = "", r = 0; r < arguments.length; r++) {
          var n = arguments[r];
          n && (t = a(t, f(n)));
        }
        return t;
      }
      function f(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return s.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var r = "";
        for (var n in t)
          u.call(t, n) && t[n] && (r = a(r, n));
        return r;
      }
      function a(t, r) {
        return r ? t ? t + " " + r : t + r : t;
      }
      e.exports ? (s.default = s, e.exports = s) : window.classNames = s;
    })();
  }(o)), o.exports;
}
var l = /* @__PURE__ */ p();
const m = /* @__PURE__ */ c(l);
export {
  m as c
};
